export function debounceCallback(fn, delay) {
  let timer = null;

  return (value, callback) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn(value, callback);
    }, delay);
  };
}
